import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const PolygonToolIcon = React.memo<IconProps>(
  ({ className = '', size = 16, width, height, color = 'currentColor', onClick, strokeWidth = 2 }) => (
    <BaseIcon
      className={className}
      size={size}
      width={width}
      height={height}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path d="M5 8l6-4 8 4-2 10H7z" stroke={color} strokeWidth={strokeWidth} fill="none" />
    </BaseIcon>
  ),
);

PolygonToolIcon.displayName = 'PolygonToolIcon';
